<template>
	<div class="container-fluid" id="dvcrud">
		<div class="row">
			<div class="col-md-12">
					<breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
			</div>
			<div class="col-md-12">
				<div id="pnlista" class="card" style="display: none;">
					<div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
						<router-link to="/">
								<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</router-link>
					</div>
					<div class="card-body" style="padding: 10px;">
						<div class="row">
							<div class="col-sm-4 col-md-2 col-lg-2">
								<label for="cbopfiltro">Filtrar:</label>
								<select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                  <option value="0">Código</option>
                  <option value="1">Nome</option>
								</select>
							</div>
							<div class="col-sm-8 col-md-4 col-lg-4">
								<label for="edconteudopesq">Conteúdo da pesquisa:</label>
								<input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
							</div>
							<div class="col-sm-2 col-md-2 col-lg-2">
								<label for="cbqtdreg">Situação:</label>
								<select name="cbSituacao" class="form-control form-control-sm" id="cbSituacao" v-model="psituacao" @change="mtdlimpar_listagem()">
									<option value="0">Ativos</option>
									<option value="1">Inativos</option>
									<option value="2">Todos</option>
								</select>
							</div>														
							<div class="col-6 col-sm-6 col-md-2 col-lg-2">
								<label for="cbqtdreg">Registros:</label>
								<select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
									<option value="10">10</option>
									<option value="20">20</option>
									<option value="30">30</option>
									<option value="40">40</option>
									<option value="50">50</option>
									<option value="99999999999">Todos</option>
								</select>
							</div>
							<div class="col-6 col-sm-6 col-md-2 col-lg-2">
								<button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
							</div>
							<div class="col-md-12" style="margin-top: 10px;">
								<vue-bootstrap4-table
												:rows="lstmotoristas"
												:columns="columns"
												:config="config"
												:classes="classes">
									<template slot="empty-results">
											<div class="col-md-12 text-center">Sem dados para visualização</div>
									</template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->									
									<template slot="id_f" slot-scope="item">
											{{ item.row.id }}
									</template>
									<template slot="ativo_f" slot-scope="item">
										<span v-if="item.row.ativo === 0" class="badge badge-pill badge-primary">Ativo</span>
										<span v-else class="badge badge-pill badge-danger">Inativo</span>
									</template>                  									
									<template slot="opcoes" slot-scope="item">
											<button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
											<button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
									</template>
								</vue-bootstrap4-table>
							</div>
							<div class="col-md-12">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
											Registros
											<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstmotoristas.length}}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="card-footer" style="padding: 10px;">
						<div class="row">
							<div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
								<v-pagination
												v-model="pagina_atual"
												:page-count="pqtd_paginas"
												:classes="bootstrapPaginationClasses">
								</v-pagination>
							</div>
							<div class="col-4 col-sm-4 col-md-2 col-lg-2">
								<button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
							</div>
						</div>
					</div>
				</div>

				<div id="pncadastro" class="card" style="display:none;">
					<div class="card-header"><span>{{itensbc.item2.titulo}}</span>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edid">Código:</label>
								<input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
												maxlength="20" style="text-transform: uppercase;" disabled/>
							</div>
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="ednome">*Nome:</label>
								<input type="text" v-model="vnome" v-bind:disabled="ativadesativa"
												class="form-control form-control-sm" id="ednome" maxlength="50"
												style="text-transform: uppercase;">
							</div>              
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbativo">Situação:</label>
								<select class="form-control form-control-sm" id="cbativo" v-model="vativo"
												v-bind:disabled="ativadesativa">
									<option value="0">Ativo</option>
									<option value="1">Inativo</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2" v-if="opcrud === 1"> 
								<label for="eddtcadastro_fk">Dt. Cadastro:</label>
								<input type="text" disabled="disabled"
												class="form-control form-control-sm" id="eddtcadastro_fk">                               
							</div>														
							<div class="col-sm-12 col-md-2 col-lg-2" v-else>
								<label for="eddtcadastro">Dt. Cadastro:</label>
								<date-picker id="eddtcadastro" v-model="vdtcadastro" :config="options" class="form-control form-control-sm" disabled="disabled"></date-picker>
							</div> 
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edcep">*Cep:</label>
								<input type="text" v-model="vcep" v-bind:disabled="ativadesativa" v-mask="'#####-###'"
									class="form-control form-control-sm" id="edcep">
							</div>
							<div class="col-sm-12 col-md-8 col-lg-8">
								<label for="edlogradouro">Endereço:</label>
								<input type="text" v-model="vlogradouro" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edlogradouro" maxlength="100"
									style="text-transform: uppercase;">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="ednrendereco">Nº Endereço:</label>
								<input type="text" v-model="vnrendereco" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="ednrendereco" maxlength="20"
									style="text-transform: uppercase;">
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<label for="edreferencia">Referência:</label>
								<input type="text" v-model="vreferencia" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edreferencia" maxlength="100"
									style="text-transform: uppercase;">
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="cbbairro">*Bairro:</label>
								<select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="cbmunicipio">*Município:</label>
								<select id="cbmunicipio" v-model="vidmunicipio"
										v-bind:disabled="ativadesativa"
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbuf">*Estado:</label>
								<select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
										data-placeholder="Selecione a uf" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edcpf">CPF</label>
								<input type="text" v-model="vcpf" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edcpf"
									v-mask="'###.###.###-##'">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edrg">RG:</label>
								<input type="text" v-model="vrg" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edrg" maxlength="20">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edfone1">Fone:</label>
								<input type="text" v-model="vfone1" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edfone1"
									v-mask="['(##) ####-####', '(##) #####-####']">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edfone2">Fone:</label>
								<input type="text" v-model="vfone2" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edfone2"
									v-mask="['(##) ####-####', '(##) #####-####']">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edcelular">Celular:</label>
								<input type="text" v-model="vcelular" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edcelular"
									v-mask="['(##) ####-####', '(##) #####-####']">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtnascimento">Dt. Nascimento:</label>
								<date-picker id="eddtnascimento" v-model="vdtnascimento" :config="options" 
									class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
							</div>               
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edcnh">CNH:</label>
								<input type="text" v-model="vcnh" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edcnh" maxlength="20">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edlocalexpcnh">Local expedição:</label>
								<input type="text" v-model="vlocalexpcnh" v-bind:disabled="ativadesativa"
									class="form-control form-control-sm" id="edlocalexpcnh" maxlength="30" style="text-transform: uppercase;">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbcategoriacnh">Categoria:</label>
								<select class="form-control form-control-sm" id="cbcategoriacnh" v-model="vcategoriacnh"
												v-bind:disabled="ativadesativa">
									<option value="0">A</option>
									<option value="1">B</option>
                  <option value="2">C</option>
                  <option value="3">D</option>
                  <option value="4">E</option>
                  <option value="5">AB</option>
                  <option value="6">AC</option>
                  <option value="7">AD</option>
                  <option value="8">AE</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtvalidadecnh">Dt. Validade:</label>
								<date-picker id="eddtvalidadecnh" v-model="vdtvalidadecnh" :config="options" 
									class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtprihabilitacao">Dt. Habilitação:</label>
								<date-picker id="eddtprihabilitacao" v-model="vdtprihabilitacao" :config="options" 
									class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbtpsanguineo">Tp. Sanguíneo:</label>
								<select class="form-control form-control-sm" id="cbtpsanguineo" v-model="vtpsanguineo"
												v-bind:disabled="ativadesativa">
									<option value="0">A+</option>
									<option value="1">A-</option>
                  <option value="2">B+</option>
                  <option value="3">B-</option>
                  <option value="4">AB+</option>
                  <option value="5">AB-</option>
                  <option value="6">O+</option>
                  <option value="7">O-</option>
								</select>
							</div>                           
						</div>

						<div class="row">
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="edpai">Pai:</label>
								<input type="text" v-model="vpai" v-bind:disabled="ativadesativa"
										class="form-control form-control-sm" id="edpai" maxlength="50"
										style="text-transform: uppercase;">
							</div>																												
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="edmae">Mãe:</label>
								<input type="text" v-model="vmae" v-bind:disabled="ativadesativa"
										class="form-control form-control-sm" id="edmae" maxlength="50"
										style="text-transform: uppercase;">
							</div>						
						</div>

						<div class="row" style="margin-top: 10px;">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<label for="edobs">Observações:</label>
								<div class="form-group">
									<textarea class="form-control" v-bind:disabled="ativadesativa"
										rows="6" id="edobs" v-model="vobs" style="text-transform: uppercase;"></textarea>
								</div>
							</div>
						</div>
					</div>

					<div class="card-footer">
						<div class="row">
							<div class="col-sm-8">
								<h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
							</div>
							<div class="col-sm-2">
								<button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
												v-bind:disabled="validou" class="btn btn-primary btn-sm"
												style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
								</button>
								<button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
												v-bind:disabled="validou" class="btn btn-primary btn-sm"
												style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
								</button>
								<button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
												v-bind:disabled="validou" class="btn btn-primary btn-sm"
												style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
								</button>
							</div>
							<div class="col-sm-2">
								<button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
										<i class="fa fa-close"></i> Cancelar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import BreadCrumb from '../components/cmpbreadcrumb.vue'
	import VueBootstrap4Table from 'vue-bootstrap4-table'
	import vPagination from 'vue-plain-pagination'
	import Swal from "sweetalert2/dist/sweetalert2.js"
    import "sweetalert2/dist/sweetalert2.min.css"
	import util from '../utilitarios/util.js'

	export default {
		name: 'cadmotoristas',
		components:{
			VueBootstrap4Table,
			vPagination,
			'breadcrumb' : BreadCrumb
		},
		data: function() {
			return {
				lstmotoristas         : [],
				pfiltro               :  1,
				pconteudo             : '',
				pqtdregistros         : 10,
				pqtd_paginas          :  1,
				pagina_atual          :  1,
				pqtd_total_registros  :  0,
				psituacao             :  0,

				//variáveis do crud
				opcrud                :  0,
				vid                   : '',
        vativo                :  0,
        vdtcadastro 					: util.DataAtual(true),
        vnome                 : '',
				vcep                  : '',
				vlogradouro           : '',
				vnrendereco           : '',
				vreferencia           : '',
				vidbairro             : null,
				vidmunicipio          : null,
				viduf                 : null,
				vcpf                  : '',
        vrg                   : '',
				vfone1                : '',
				vfone2                : '',
        vcelular              : '',
        vemail                : '',
        vcnh                  : '', 
        vlocalexpcnh          : '',
        vcategoriacnh         :  0,
        vdtvalidadecnh        : null,
        vdtprihabilitacao     : null,
        vdtnascimento         : null,
        vtpsanguineo          :  0, 
        vpai                  : '', 
        vmae                  : '',  
				vobs                  : '',

				options: {
					format              : 'DD/MM/YYYY',
					useCurrent          : false,
					locale              : 'pt-BR'
				},

				//variável para habilitação dos campos
				ativadesativa         : true,

				bootstrapPaginationClasses: {
					ul: 'pagination pagination-sm',
					li: 'page-item',
					liActive: 'active',
					liDisable: 'disabled',
					button: 'page-link'
				},
				itensbc : {
					item1 : {
						titulo : 'MOTORISTAS',
						ativo  : false
					},
					item2 : {
						titulo : '',
						ativo  : false
					}
				},
				columns: [
					{
            label: 'Opções',
            name : 'opcoes',
            row_text_alignment: "text-center",
            column_text_alignment: "text-center",
            row_classes: "def-col-opcoes",
            sort: false
					},
					{
						label: "Código",
						name: "id",
						sort: true,
						slot_name: "id_f",
						row_classes: "def-col-cod",
					},
					{
						label: "Situação",
						name: "ativo",
						initial_sort : true,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-center",
						column_text_alignment: "text-center",
						slot_name: "ativo_f",
						row_classes: "def-col-ativo"
					}, 						
					{
						label: "Nome",
						name: "nome",
						initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-left",
						column_text_alignment: "text-left"
          }          
				],
				config: {
					pagination: false,
					pagination_info: false,
					card_mode: false,
					global_search: {
							visibility: false,
					},
					show_refresh_button : false,
					show_reset_button : false
				},
				classes: {
					table: "table-bordered table-striped table-sm"
				}
			}
		},
		methods:{
			mtdfiltropesquisa(){
				let rfiltro = '';

				switch (parseInt(this.pfiltro)) {
						case 0:
								rfiltro = this.pconteudo === '' ? '' : ' and mt.id='+this.pconteudo;
								break;
						case 1:
								rfiltro = this.pconteudo === '' ? '' : ' and upper(mt.nome) like upper(\''+this.pconteudo+'%\')';
								break;                                                                                                                                           
				}

				switch (parseInt(this.psituacao)) {
					case 0:
							rfiltro = rfiltro + ' and mt.ativo=0';
							break;
					case 1:
							rfiltro = rfiltro + ' and mt.ativo=1';
							break;                   
				}
												
				return rfiltro;
			},
			mtdexecutapesquisa(){
				var vself           = this;
				let filtro          = vself.mtdfiltropesquisa();
				this.pagina_atual   = 1;
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor  : 'qtdregistros'},
					{parametro: 'filtro',       valor  : filtro}
				];
        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmotoristas.php');
        
				retorno.then(function (response) {
					vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
					let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
					vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
					vself.mtdcarregamotoristas(1);
				}).catch(function (response) {
					alert('Erro ao consultar registros');
				});
			},
			mtdcarregamotoristas(ipagina){
				var vself       = this;
				let loader      = this.$loading.show();
				let filtro      = vself.mtdfiltropesquisa();
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'limit',        valor : vself.pqtdregistros},
					{parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmotoristas.php');
				retorno.then(function (response) {
					vself.lstmotoristas = response.data;
					loader.hide();
				}).catch(function (response) {
					vself.lstmotoristas = [];
					loader.hide();
				});
			},
			resetarDados() {
					util.toTop();

					this.vid                = '';
          this.vativo             =  0;
          this.vdtcadastro        = util.DataAtual(true);
          this.vnome              = '';
					this.vcep               = '';
					this.vlogradouro        = '';
					this.vnrendereco        = '';
					this.vreferencia        = '';
					this.vidbairro          = null;
					this.vidmunicipio       = null;
					this.viduf              = null;
					this.vcpf               = '';
          this.vrg                = '';
					this.vfone1             = '';
					this.vfone2             = '';
          this.vcelular           = '';
					this.vemail             = '';
          this.vcnh               = '';
          this.vlocalexpcnh       = '';
          this.vcategoriacnh      =  0;
          this.vdtvalidadecnh     = null;
          this.vdtprihabilitacao  = null;
          this.vdtnascimento      = null;
          this.vtpsanguineo       =  0;
          this.vpai               = '';
          this.vmae               = '';
					this.vobs               = '';

					$("#cbbairro").val('').trigger('change');
					$("#cbmunicipio").val('').trigger('change');
					$("#cbuf").val('').trigger('change');
			},
			mtddefault(){
				$('#pnlista').hide();
				this.resetarDados();
				$('#pncadastro').fadeIn(700);
				this.$nextTick(function () {
					if (parseInt(this.opcrud) < 3) {
						$('#ednome').focus();
					} else {
						$('#btgravar').focus();
					}
				});
			},
			mtdpreparacrud(op) {
				let vself    = this;
				vself.opcrud = op;
				vself.mtddefault();
			},
			mtdnovo(){
				if (!util.opcaousuario('002Z.009M.001M', this.$store.state.perfilusuario)){
					util.notif("warning", 'Acesso não permitido para o usuário!');
				}else {
					this.itensbc.item2.titulo = 'INCLUSÃO DE MOTORISTAS';
					this.itensbc.item1.ativo  = true;
					this.itensbc.item2.ativo  = true;
					this.ativadesativa        = false;
					this.mtdpreparacrud(1);
				}
			},
			mtdcancelaredicao(){
				this.itensbc.item1.ativo = false;
				this.itensbc.item2.ativo = false;
				$('#pncadastro').hide();
				$('#pnlista').fadeIn(700);
				$('#edconteudopesq').focus();
				setTimeout(function(){
					util.toTop();
				}, 200);
			},
			mtdlimpar_listagem() {
				this.lstmotoristas        = [];
				this.pagina_atual         = 1;
				this.filtro               = '';
				this.pqtd_total_registros = 0;
				this.pqtd_paginas         = 0;
			},
			mtdgravar(){
				let vself = this;
				if (parseInt(vself.opcrud) < 3) {
					if (parseInt(vself.vtodasfiliais) === 0) {
					}
				}
				Swal.fire({
					customClass: {
						confirmButton: "btn btn-success conf",
						cancelButton: "btn btn-danger"
					},
					title: "Confirmação",
					text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
					icon: "question",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Sim",
					cancelButtonText: "Cancelar"
				}).then((result) => {
					if (result.isConfirmed) {
						$('.conf').prop('disabled', true);
						vself.mtdregistro();
					} else {
						$('#btgravar').focus();
					}
				});
			},
			mtdlocalizaregistro(id){
				var vself       = this;
				let loader      = vself.$loading.show();
				let filtro      = ' and mt.id='+id;
				let parametros  = [
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'limit',        valor : 1},
					{parametro: 'offset',       valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmotoristas.php');
				retorno.then(function (response) {
					loader.hide();
					vself.mtdigualarcampos(response.data[0]);
					if (parseInt(vself.opcrud) < 3){
						$('#ednome').focus();
					}else{
						$('#btgravar').focus();
					}
				}).catch(function (response) {
					loader.hide();
				});
			},
			mtdalterar(item){
				if (!util.opcaousuario('002Z.009M.002M', this.$store.state.perfilusuario)){
					util.notif("warning", 'Acesso não permitido para o usuário!');
				}else {
					this.itensbc.item2.titulo = 'ALTERAÇÃO DE MOTORISTAS';
					this.itensbc.item1.ativo  = true;
					this.itensbc.item2.ativo  = true;
					this.ativadesativa        = false;
					this.mtdpreparacrud(2);
					this.mtdlocalizaregistro(item.id);
				}
			},
			mtdexcluir(item){
				if (!util.opcaousuario('002Z.009M.003M', this.$store.state.perfilusuario)){
					util.notif("warning", 'Acesso não permitido para o usuário!');
				}else {
					this.itensbc.item2.titulo = 'EXCLUSÃO DE MOTORISTAS';
					this.itensbc.item1.ativo  = true;
					this.itensbc.item2.ativo  = true;
					this.ativadesativa        = true;
					this.mtdpreparacrud(3);
					this.mtdlocalizaregistro(item.id);
				}
			},
			mtdigualarcampos(registro){
				this.vid                 = registro.id;
        this.vativo              = registro.ativo;
        this.vdtcadastro         = registro.dtcadastro;
        this.vnome               = registro.nome;
				this.vcep                = registro.cep;
				this.vlogradouro         = registro.logradouro;
				this.vnrendereco         = registro.nrendereco;
				this.vreferencia         = registro.referencia;
				this.vidbairro           = registro.idbairro;
				this.vidmunicipio        = registro.idmunicipio;
				this.viduf               = registro.iduf;
				this.vcpf                = registro.cpf;
        this.vrg                 = registro.rg;
				this.vfone1              = registro.fone1;
				this.vfone2              = registro.fone2
        this.vcelular            = registro.celular;
				this.vemail              = registro.email;
        this.vcnh                = registro.cnh;
        this.vlocalexpcnh        = registro.localexpcnh;
        this.vcategoriacnh       = registro.categoriacnh;
        this.vdtvalidadecnh      = registro.dtvalidadecnh;
        this.vdtprihabilitacao   = registro.dtprihabilitacao;
        this.vdtnascimento       = registro.dtnascimento;
        this.vtpsanguineo        = registro.tpsanguineo;
        this.vpai                = registro.pai; 
        this.vmae                = registro.mae; 
				this.vobs                = registro.obs;

				var defbairro             = new Option(registro.descbairro, registro.idbairro, true, true);
				$('#cbbairro').append(defbairro).trigger('change');

				var defmunic              = new Option(registro.descmunic, registro.idmunicipio, true, true);
				$('#cbmunicipio').append(defmunic).trigger('change');

				var defuf                 = new Option(registro.descuf, registro.iduf, true, true);
				$('#cbuf').append(defuf).trigger('change');
			},
			mtdregistro(){
				let vself  = this;
				let loader = vself.$loading.show();
				let registrocrud = {
					'id'                 : this.vid,
          'ativo'              : this.vativo,
          'dtcadastro'         : this.vdtcadastro,  
          'nome'               : this.vnome,
					'cep'                : this.vcep.replace(/[^0-9]/g,''),
					'logradouro'         : this.vlogradouro,
					'nrendereco'         : this.vnrendereco,
					'referencia'         : this.vreferencia,
					'idbairro'           : this.vidbairro,
					'idmunicipio'        : this.vidmunicipio,
					'iduf'               : this.viduf,
					'cpf'                : this.vcpf.replace(/[^0-9]/g,''),
          'rg'                 : this.vrg.replace(/[^0-9]/g,''),
					'fone1'              : this.vfone1.replace(/[^0-9]/g,''),
					'fone2'              : this.vfone2.replace(/[^0-9]/g,''),
          'celular'            : this.vcelular.replace(/[^0-9]/g,''),
          'email'              : this.vemail,
          'cnh'                : this.vcnh,
          'localexpcnh'        : this.vlocalexpcnh,
          'categoriacnh'       : this.vcategoriacnh,
          'dtvalidadecnh'      : this.vdtvalidadecnh,
          'dtprihabilitacao'   : this.vdtprihabilitacao,
          'dtnascimento'       : this.vdtnascimento,
          'tpsanguineo'        : this.vtpsanguineo,
          'pai'                : this.vpai,
          'mae'                : this.vmae,
					'obs'                : this.vobs
				};
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'rotinacrud'},
					{parametro: 'opcrud',       valor : vself.opcrud},
					{parametro: 'registro',     valor : JSON.stringify(registrocrud)},
					{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
					{parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '002Z.009M.001M' : parseInt(this.opcrud) === 2 ? '002Z.009M.002M' : '002Z.009M.003M'},
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmotoristas.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						util.notif("success", 'Registro processado com sucesso!')
						vself.pfiltro       = 0;
						vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
						vself.pqtd_paginas  = 1;
						vself.mtdcancelaredicao();
						vself.mtdcarregamotoristas(1);
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								util.notif("warning", response.data.substring(4))
								break;
							case 'E': default:
								util.notif("error", response.data.substring(4))
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
				});
			},			
			mtdselect2_def(){
				let vself  = this;

				$("#edcep").blur(function(){
					vself.mtdpesquisacep();
				});

				$("#cbbairro").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbairros',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidbairro = $("#cbbairro").val();
				});

				$("#cbmunicipio").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmunicipios',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 3,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidmunicipio = $("#cbmunicipio").val();
				});

				$("#cbuf").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbufs',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.viduf = $("#cbuf").val();
				});
			},
			mtdpesquisacep(){				
				let vself = this;
				let cepinf = vself.vcep;
				if ( cepinf != ''){
					if (util.IsCEP(cepinf, '')){
						let loader = vself.$loading.show();
						let parametros = [
							{parametro: 'param1', 		valor: 'consultarcep'},
							{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'cep', 			valor: cepinf}
						];
						let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/buscarcep.php');
						retorno.then(function (response) {
							loader.hide();
							if (response.data != '0') {
								var defmun            = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
								$('#cbmunicipio').append(defmun).trigger('change');

								var defbai            = new Option(response.data.descbairro, response.data.idbairro, true, true);
								$('#cbbairro').append(defbai).trigger('change');

								var defuf             = new Option(response.data.descuf, response.data.iduf, true, true);
								$('#cbuf').append(defuf).trigger('change');

								vself.vlogradouro     = response.data.logradouro;
								vself.vreferencia     = response.data.complemento;
							}else{
								util.notif("warning", 'CEP inválido ou inexistente!');
							}

						}).catch(function (response) {
							loader.hide();
							console.log(response.message);
						});
					}
				}
			},				
		},
		mounted: function () {
			if (util.verificasessao(this)) {
					let vself = this;
					let loader = vself.$loading.show();
					let parametros = [
							{parametro: 'op', valor: 'dadosusuario'},
							{parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
							{parametro: 'idusuario', valor: vself.$store.state.usuario.id}
					];
					let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
					retorno.then(function (response) {
							loader.hide();
							vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
							if (util.opcaousuario('002Z.009M', vself.$store.state.perfilusuario)) {
									$('#pnlista').fadeIn(700);
									vself.mtdexecutapesquisa();
									vself.mtdselect2_def();
							} else {
									util.notif("warning", 'Acesso não permitido para o usuário!');
									setTimeout(function(){
											util.gotoprincipal();
									},1000);
							}
					}).catch(function (response) {
							loader.hide();
							console.log(response.message);
					});
			}
		},
		computed:{
				validou() {
						return this.vdescricao === '' || this.vcep === '' || this.vidbairro === null ||
										this.vidmunicipio === null || this.viduf === '';
				}
		},
		watch:{
				pagina_atual(val){
						this.mtdcarregamotoristas(val);
				}
		}
	}
</script>
<style>
	.def-col-cod{
		width: 80px !important;
	} 
	.def-col-ativo{
		width: 80px !important;
	} 	
	#btclonarperfilusuario{
		cursor: pointer;
		font-weight: bold;
		font-size: 18px;
		position: relative;
		float: right;
		top: 5px;
		transition: .35s;
	}
	#btmarcartodosopusuario{
		font-weight: bold;
		font-size: 18px;
		padding-right: 10px;
		cursor: pointer;
		position: relative;
		float: right;
		top: 5px;
		transition: .35s;
	}
	#btmarcartodosopusuario:hover{
		color: #666666;
		transition: .35s;
	}

	#btmarcartodfiliais{
		font-weight: bold;
		font-size: 18px;
		padding-right: 10px;
		cursor: pointer;
		position: relative;
		float: right;
		top: 5px;
		transition: .35s;
	}
	#btmarcartodfiliais:hover{
		color: #666666;
		transition: .35s;
	}
	#btclonarperfilusuario:hover{
		color: #666666;
		transition: .35s;
	}
</style>